export default __webpack_public_path__ + "static/2461-d0e424ae1cf9158148a612b761120187.gif";